import script from "./languageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./languageView.vue?vue&type=script&lang=ts&setup=true"

import "./languageView.vue?vue&type=style&index=0&id=19176c20&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19176c20"]])

export default __exports__